import React, { useEffect, useState } from 'react'

export const useMapLayout = (
  containerRef: React.RefObject<HTMLDivElement>,
  threshold = 450
): { isColumnLayout: boolean } => {
  const [isColumnLayout, setIsColumnLayout] = useState(false)

  useEffect(() => {
    if (!containerRef.current) return

    const containerObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const { width } = entry.contentRect
        setIsColumnLayout(width < threshold)
      }
    })

    containerObserver.observe(containerRef.current)

    const initialWidth = containerRef.current.getBoundingClientRect().width
    setIsColumnLayout(initialWidth < threshold)

    return () => {
      containerObserver.disconnect()
    }
  }, [containerRef, threshold])

  return { isColumnLayout }
}

export default useMapLayout
